import { render, staticRenderFns } from "./greenTips.vue?vue&type=template&id=2d38e2cd&scoped=true&"
import script from "./greenTips.vue?vue&type=script&lang=js&"
export * from "./greenTips.vue?vue&type=script&lang=js&"
import style0 from "./greenTips.vue?vue&type=style&index=0&id=2d38e2cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38e2cd",
  null
  
)

export default component.exports